import { WhatsappLogo } from '@phosphor-icons/react';
import { useSettings } from '@/context/SettingsContext';
import { NAV } from '@/constants/testIds';

export default function WhatsAppFAB() {
  const { settings } = useSettings();
  const number = settings.whatsapp_number || '919971236105';
  const msg = encodeURIComponent("Hi MyZippyKart, I need help with my order.");
  const pos = settings?.appearance?.whatsapp_position === 'bottom-left' ? 'left-4 md:left-6' : 'right-4 md:right-6';
  return (
    <a
      data-testid={NAV.whatsappButton}
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      className={`fixed z-40 bottom-20 md:bottom-6 ${pos} h-14 w-14 rounded-full text-white shadow-lg shadow-fresh-900/20 grid place-items-center hover:scale-105 active:scale-95 transition-transform`}
      style={{ backgroundColor: 'var(--app-whatsapp-bg, #25D366)' }}
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
      <span className="sr-only">WhatsApp Support</span>
    </a>
  );
}
